export default {
  name: "statistics-workload"
};